import * as classnames from 'classnames'
import * as React from 'react'
import { forceCheck as forceLazyloadViewportCheck } from 'react-lazyload'

import CardArea from './cardArea/cardArea'

import * as styles from './itemCardsLayout.module.css'

interface IProps {
  viewType?: string
  children?: React.ReactNode
}

class ItemCardsLayout extends React.Component<IProps> {
  public static CardArea: typeof CardArea

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.viewType !== this.props.viewType) {
      forceLazyloadViewportCheck()
    }
  }

  public render() {
    const className = classnames(styles.root, {
      [styles.listView]: this.props.viewType === 'list'
    })
    const testSelector = `item-cards-layout-${this.props.viewType}`
    return (
      <ul className={className} data-test-selector={testSelector}>
        {this.props.children}
      </ul>
    )
  }
}

ItemCardsLayout.CardArea = CardArea
ItemCardsLayout.CardArea.displayName = 'ItemCardsLayout.CardArea'

export default ItemCardsLayout
